module.exports = __webpack_public_path__ + "static/media/Inter-UI-Regular.19ef7850.woff2";